import { Injectable } from '@angular/core';
import { ListPagedImportedProductsRequest, SituViewWebApiClient } from 'situview-webapi-client';
import { BannerService, BannerServiceStatus } from './banner.service';
import { Guid } from 'guid-typescript';


@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private importedProductCount = 0;

  constructor(
    private situViewWebApiClient: SituViewWebApiClient,
    private bannerService: BannerService) {
    this.updateImportedProductsNotification();
  }

  private importProductMessageId = Guid.parse('d33040ec-6fa3-42d4-af0c-3f71610b0082');

  public updateImportedProductsNotification() {
    const req = { pageNumber: 1, pageSize: 1 } as ListPagedImportedProductsRequest;
    // this.situViewWebApiClient.listPagedImportedProducts(req).then((response) => {
    //   this.importedProductCount = response.totalItems ?? 0;
    //   if (!!this.importedProductCount) {
    //     let msg = `There are ${this.importedProductCount} product${this.importedProductCount > 1
    //       ? 's' : ''} waiting to be imported. <a href='/products-import-preview'>Click here</a> to import or purge them now.`
    //     this.bannerService.AddMessage(msg, BannerServiceStatus.info, this.importProductMessageId);
    //   }
    //   else {
    //     this.bannerService.RemoveMessage(this.importProductMessageId);
    //   }
    // }, error => {
    //   console.log("Unable to load imported products")
    // });
  }
}
